module.exports = __webpack_public_path__ + "static/media/bonarka15.36c8aaa2.jpg";